const Unit = {
  queryList: [
    {
      name: 'code',
      label: '单位代码',
      component: 'input'
    },
    {
      name: 'name',
      label: '单位名称',
      component: 'input'
    },
    {
      name: 'type',
      label: '单位属性',
      component: 'select',
      componentAttr: {
        options: [{
          value: 1,
          label: '学校'
        }, {
          value: 2,
          label: '其他'
        }]
      }
    }
  ],
  urlMap: {
    select: '/school/school/list',
    update: '/school/school/updateEnableDisable',
    delete: '/school/school/delete'
  },
  operList: [
    {
      name: 'add',
      label: '新增',
      show: true,
      action: {
        type: 'dialog',
        addr: 'systemManage/unitEdit'
      }
    }
  ],
  titles: [
    {
      name: 'name',
      label: '单位名称'
    },
    {
      name: 'code',
      label: '单位代码'
    },
    {
      name: 'startTime',
      label: '开始时间'
    },
    {
      name: 'endTime',
      label: '结束时间'
    },
    {
      name: 'enableDisable',
      label: '状态',
      map: {
        0: '停用',
        1: '启用'
      },
      action: {
        label: '更改',
        type: 'request',
        addr: 'update',
        data: {id: '{id}', enableDisable: '({enableDisable}?0:1)'}
      }
    },
    {
      name: 'operation',
      label: '操作',
      actionList: [
        {
          label: '修改',
          kind: 'primary', // error
          type: 'dialog', // request, router, dialog, func
          addr: 'systemManage/unitEdit?{id}'
        },
        {
          label: '删除',
          kind: 'primary',
          type: 'request',
          addr: 'delete',
          data: ['{id}'],
          confirm: {
            desc: '确认删除？'
          }
        }
      ]
    }
  ]
}
export default Unit



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/systemManage/unit.js